import { render, staticRenderFns } from "./sources-of-recommendations.vue?vue&type=template&id=4e1dddad&scoped=true"
import script from "./sources-of-recommendations.vue?vue&type=script&lang=js"
export * from "./sources-of-recommendations.vue?vue&type=script&lang=js"
import style0 from "./sources-of-recommendations.vue?vue&type=style&index=0&id=4e1dddad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1dddad",
  null
  
)

export default component.exports